module.exports = __webpack_public_path__ + "static/media/PYC DE NGHI HUY GIAO DICH THE- HOAN TRA PHI -JULY2021.f296392d.pdf";